module.exports = __webpack_public_path__ + "6f5fe8db6f61813af564007deb147626.svg";